import { apiProxyRequest, apiProxyRequestFresh } from "Api/apiProxyRequest";
import { encodeParameters } from "Api/utils";

import type { DeploymentRequestProps, Deployment } from "./types";

export const loadDeploymentCurrentRequest = ({
  projectId,
  environmentId,
  verbose,
  fresh
}: DeploymentRequestProps) => {
  const { projectId: encodedProjectId, environmentId: encodedEnvironmentId } =
    encodeParameters({ projectId, environmentId });
  const verboseQueryParam = verbose ? `?verbose=true` : "";
  const url = `/projects/${encodedProjectId}/environments/${encodedEnvironmentId}/deployments/current${verboseQueryParam}`;

  return fresh
    ? apiProxyRequestFresh<Deployment>(url)
    : apiProxyRequest<Deployment>(url);
};
